import React, { useState, useEffect, useRef, useContext } from "react";
import { downloadCsv } from "../common/sharedFunctions";
import MaterialTable from "material-table";
import { useSelector, useDispatch } from "react-redux";
import CircularLoading from "../components/CircularLoading";
import { api, FirebaseContext } from "common";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams,useLocation } from "react-router-dom";
import moment from 'moment/min/moment-with-locales';
import { colors } from "../components/Theme/WebTheme";
import AlertDialog from "../components/AlertDialog";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Switch from "@mui/material/Switch";
import { Typography, Select, MenuItem, FormControl, Tabs, Tab, Box, IconButton, Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import {MAIN_COLOR,SECONDORY_COLOR, FONT_FAMILY} from "../common/sharedFunctions"
import EditIcon from '@mui/icons-material/Edit';
import { ThemeProvider } from '@mui/material/styles';
import theme from "styles/tableStyle";
import BlankTable from '../components/Table/BlankTable';
import TableStyle from '../components/Table/Style';
import localization from '../components/Table/Localization';
import { makeStyles } from '@mui/styles';
import { deleteObject } from "firebase/storage";

const useStyles = makeStyles({
  tabs: {
    "& .MuiTabs-indicator": {
      backgroundColor: SECONDORY_COLOR,
      height: 3,
    },
    "& .MuiTab-root.Mui-selected": {
      color: MAIN_COLOR
    }
  },
  typography: {
    fontFamily: FONT_FAMILY
  }
});

export default function Users() {
  const navigate = useNavigate();
  const {id} = useParams();
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir();
  const classes = useStyles();
  const [tabValue, setTabValue] = useState(0);
  const firebase = useContext(FirebaseContext);
  const {
    editUser,
    deleteUser,
    fetchUsersOnce,
  } = api;
  const [data, setData] = useState([]);
  const staticusers = useSelector((state) => state.usersdata.staticusers);
  const auth = useSelector((state) => state.auth);
  const settings = useSelector((state) => state.settingsdata.settings);
  const dispatch = useDispatch();
  const loaded = useRef(false);
  const [role, setRole] = useState(null);
  const [fleetAdminsObj, setFleetAdminsObj] = useState();
  const [sortedData, SetSortedData] = useState([]);
  const {state} = useLocation()
  const [currentPage,setCurrentPage] = useState(null)
  const [declineDialog, setDeclineDialog] = useState({ open: false, rowData: null });
  const [declineReason, setDeclineReason] = useState("");

  useEffect(()=>{
    setCurrentPage(state?.pageNo)
  },[state])
  
  const HandalePageChange = (page)=>{
    setCurrentPage(page)
  }

  useEffect(() => {
    dispatch(fetchUsersOnce());
  }, [dispatch, fetchUsersOnce]);

  useEffect(() => {
    if (staticusers) {
      if (role === "admin") {
        let arr = staticusers.filter((user) => user.usertype === "fleetadmin");
        let obj = {};
        let arr2 = [];
        for (let i = 0; i < arr.length; i++) {
          let user = arr[i];
          arr2.push({
            id: user.id,
            desc:
              user.firstName +
              " " +
              user.lastName +
              " (" +
              (settings.AllowCriticalEditsAdmin
                ? user.mobile
                : t("hidden_demo")) +
              ") " +
              (settings.AllowCriticalEditsAdmin
                ? user.email
                : t("hidden_demo")),
          });
          obj[user.id] = user.firstName + " " + user.lastName;
        }
        setFleetAdminsObj(obj);
      }
      setTimeout(() => {
        setData(
          staticusers.filter(
            (user) =>
              user.usertype === "driver" &&
              ((user.fleetadmin === auth.profile.uid &&
                auth.profile.usertype === "fleetadmin") ||
                auth.profile.usertype === "admin")
          )
        );
      }, 1000);
    } else {
      setData([]);
    }
    loaded.current = true;
  }, [
    staticusers,
    auth.profile.usertype,
    auth.profile.uid,
    settings.AllowCriticalEditsAdmin,
    role,t
  ]);

  useEffect(()=>{
    if(data){
      const sorted = data.sort((a,b)=>(moment(b.createdAt) - moment(a.createdAt)));
      SetSortedData(sorted);
    }
  },[data])

  const filteredData = tabValue === 0 
    ? sortedData.filter(driver => driver.approved === true && !driver.declined)
    : tabValue === 1
    ? sortedData.filter(driver => driver.approved !== true && !driver.declined)
    : sortedData.filter(driver => driver.declined === true);

  useEffect(() => {
    if (auth.profile && auth.profile.usertype) {
      setRole(auth.profile.usertype);
    }
  }, [auth.profile]);

 
  const handelApproved = (rowData) => {
    const updatedUser = { ...rowData, approved: !rowData.approved, adminApprovedTrue:true, declined: false };

    dispatch(editUser(updatedUser.id, updatedUser));
    dispatch(fetchUsersOnce());
    return updatedUser;
  };

  const handleDeclineClick = (rowData) => {
    setDeclineDialog({ open: true, rowData });
    setDeclineReason("");
  };

  const handleDeclineConfirm = async () => {
    if (!declineReason.trim()) {
      setCommonAlert({ open: true, msg: t("decline_reason_required") || "Please provide a reason for declining" });
      return;
    }

    const rowData = declineDialog.rowData;
    const updatedUser = { 
      ...rowData, 
      declined: true, 
      approved: false,
      declineReason: declineReason.trim(),
      declinedAt: new Date().toISOString()
    };

    try {
      const deletePromises = [];
      
      if (rowData.idCardFront) {
        deletePromises.push(deleteObject(firebase.idCardFrontRef(rowData.id)).catch(() => {}));
      }
      if (rowData.idCardBack) {
        deletePromises.push(deleteObject(firebase.idCardBackRef(rowData.id)).catch(() => {}));
      }
      if (rowData.licenseImage) {
        deletePromises.push(deleteObject(firebase.driverDocsRef(rowData.id)).catch(() => {}));
      }
      if (rowData.licenseImageBack) {
        deletePromises.push(deleteObject(firebase.driverDocsRefBack(rowData.id)).catch(() => {}));
      }
      
      await Promise.all(deletePromises);
      
      updatedUser.idCardFront = null;
      updatedUser.idCardBack = null;
      updatedUser.licenseImage = null;
      updatedUser.licenseImageBack = null;
      updatedUser.verifyIdImage = null;
      
      dispatch(editUser(updatedUser.id, updatedUser));
      dispatch(fetchUsersOnce());
      setDeclineDialog({ open: false, rowData: null });
      setDeclineReason("");
    } catch (error) {
      console.error('Error deleting documents:', error);
      dispatch(editUser(updatedUser.id, updatedUser));
      dispatch(fetchUsersOnce());
      setDeclineDialog({ open: false, rowData: null });
      setDeclineReason("");
    }
  };
  const handelDriverActiveStatus = (rowData) => {
    const updatedUser = {
      ...rowData,
      driverActiveStatus: !rowData.driverActiveStatus,
    };

    dispatch(editUser(updatedUser.id, updatedUser));
    dispatch(fetchUsersOnce());
    return updatedUser;
  };

  const handleFleetAdminChange = (rowData, fleetAdminId) => {
    const updatedUser = {
      ...rowData,
      fleetadmin: fleetAdminId || null,
    };

    dispatch(editUser(updatedUser.id, updatedUser));
    dispatch(fetchUsersOnce());
    return updatedUser;
  };

  const baseColumns = [
    { title: t('createdAt'), field: 'createdAt', editable:'never', defaultSort:'desc',render: rowData => rowData.createdAt? moment(rowData.createdAt).format('lll'):null,},
    {
      title: t("registration_id"),
      field: "id",
      editable:'never',
      render: rowData => {
        if (rowData.customRegistrationId) {
          return rowData.customRegistrationId;
        }
        return rowData.id ? rowData.id : '-';
      },
      customFilterAndSearch: (term, rowData) => {
        const customId = rowData.customRegistrationId || '';
        const firebaseUid = rowData.id || '';
        return customId.toLowerCase().includes(term.toLowerCase()) ||
               firebaseUid.toLowerCase().includes(term.toLowerCase());
      }
    },
    { title: t("first_name"), field: "firstName", initialEditValue: "" },
    { title: t("last_name"), field: "lastName", initialEditValue: "" },
    {
      title: t("mobile"),
      field: "mobile",
      editable: "onAdd",
      render: (rowData) =>
        settings.AllowCriticalEditsAdmin ? rowData.mobile : t("hidden_demo"),
    },
    {
      title: t("email"),
      field: "email",
      editable: "onAdd",
      render: (rowData) =>
        settings.AllowCriticalEditsAdmin ? rowData.email : t("hidden_demo"),
      headerStyle: { textAlign: "center" },
    },
    {
      title: t("profile_image"),
      field: "profile_image",
      render: (rowData) =>
        rowData.profile_image ? (
          <img
            alt="Profile"
            src={rowData.profile_image}
            style={{ width: 40, height: 40, borderRadius: "50%" }}
          />
        ) : (
          <AccountCircleIcon sx={{ fontSize: 40 }} />
        ),
      editable: "never",
    },
    {
      title: t("account_approve"),
      field: "approved",
      type: "boolean",
      render: (rowData) => (
        <Switch
          disabled={!settings.AllowCriticalEditsAdmin}
          checked={rowData.approved}
          onChange={() => handelApproved(rowData)}
        />
      ),
    },
    {
      title: t("driver_active"),
      field: "driverActiveStatus",
      editable: "never",
      type: "boolean",
      render: (rowData) => (
        <Switch
          disabled
          checked={rowData.driverActiveStatus}
          onChange={() => handelDriverActiveStatus(rowData)}
        />
      ),
    },
    {
      title: t("queue"),
      field: "queue",
      editable: "never",
      type: "boolean",
      initialEditValue: true,
      render: (rowData) => (
        <Switch
          disabled
          checked={rowData.queue}
          onChange={() => console.log(rowData.queue)}
        />
      ),
    },
    {
      title: t("fleet_admin"),
      field: "fleetadmin",
      editable: "never",
      hidden: role !== "admin",
      render: (rowData) => (
        <FormControl
          fullWidth
          size="small"
          disabled={!settings.AllowCriticalEditsAdmin}
        >
          <Select
            value={rowData.fleetadmin || ""}
            onChange={(e) => handleFleetAdminChange(rowData, e.target.value)}
            displayEmpty
            sx={{
              minWidth: 200,
              '& .MuiSelect-select': {
                padding: '8px 14px',
              }
            }}
          >
            <MenuItem value="">
              <em>{t("no_fleet_admin")}</em>
            </MenuItem>
            {fleetAdminsObj && Object.keys(fleetAdminsObj).map((key) => (
              <MenuItem key={key} value={key}>
                {fleetAdminsObj[key]}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      ),
      exportTransformer: (rowData) =>
        rowData.fleetadmin && fleetAdminsObj ? fleetAdminsObj[rowData.fleetadmin] : "",
    }
  ];

  const declinedColumns = [
    { title: t('createdAt'), field: 'createdAt', editable:'never', defaultSort:'desc',render: rowData => rowData.createdAt? moment(rowData.createdAt).format('lll'):null,},
    {
      title: t("registration_id"),
      field: "id",
      editable:'never',
      render: rowData => {
        if (rowData.customRegistrationId) {
          return rowData.customRegistrationId;
        }
        return rowData.id ? rowData.id : '-';
      },
      customFilterAndSearch: (term, rowData) => {
        const customId = rowData.customRegistrationId || '';
        const firebaseUid = rowData.id || '';
        return customId.toLowerCase().includes(term.toLowerCase()) ||
               firebaseUid.toLowerCase().includes(term.toLowerCase());
      }
    },
    { title: t("first_name"), field: "firstName", initialEditValue: "" },
    { title: t("last_name"), field: "lastName", initialEditValue: "" },
    {
      title: t("mobile"),
      field: "mobile",
      editable: "onAdd",
      render: (rowData) =>
        settings.AllowCriticalEditsAdmin ? rowData.mobile : t("hidden_demo"),
    },
    {
      title: t("email"),
      field: "email",
      editable: "onAdd",
      render: (rowData) =>
        settings.AllowCriticalEditsAdmin ? rowData.email : t("hidden_demo"),
      headerStyle: { textAlign: "center" },
    },
    {
      title: t("profile_image"),
      field: "profile_image",
      render: (rowData) =>
        rowData.profile_image ? (
          <img
            alt="Profile"
            src={rowData.profile_image}
            style={{ width: 40, height: 40, borderRadius: "50%" }}
          />
        ) : (
          <AccountCircleIcon sx={{ fontSize: 40 }} />
        ),
      editable: "never",
    },
    {
      title: t("decline_reason") || "Decline Reason",
      field: "declineReason",
      editable: "never",
      render: (rowData) => rowData.declineReason || "-",
    }
  ];

  const declineColumn = {
    title: t("decline"),
    field: "decline",
    editable: "never",
    sorting: false,
    render: (rowData) => (
      <IconButton
        onClick={() => handleDeclineClick(rowData)}
        disabled={!settings.AllowCriticalEditsAdmin}
        sx={{
          color: 'red',
          '&:hover': {
            backgroundColor: 'rgba(255, 0, 0, 0.1)'
          }
        }}
      >
        <CloseIcon />
      </IconButton>
    ),
  };

  const columns = tabValue === 0 ? baseColumns : tabValue === 1 ? [...baseColumns, declineColumn] : declinedColumns;

  const [commonAlert, setCommonAlert] = useState({ open: false, msg: "" });

  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: "" });
  };


  const [selectedRow, setSelectedRow] = useState(null);

  return !loaded.current ? (
    <CircularLoading />
  ) : (
    <div style={{ backgroundColor: colors.LandingPage_Background }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider', backgroundColor: colors.WHITE }}>
        <Tabs value={tabValue} onChange={(e, newValue) => setTabValue(newValue)} className={classes.tabs}>
          <Tab label={<Typography className={classes.typography}>Approved</Typography>} />
          <Tab label={<Typography className={classes.typography}>Pending</Typography>} />
          <Tab label={<Typography className={classes.typography}>Declined</Typography>} />
        </Tabs>
      </Box>
      <ThemeProvider theme={theme}>
      {filteredData?.length >0 ? 
        <MaterialTable
          title={t("drivers_title")}
          columns={columns}
          onChangePage={(page)=>HandalePageChange(page)}
          style={{
            direction: isRTL === "rtl" ? "rtl" : "ltr",
            borderRadius: "8px",
            boxShadow: `0px 2px 5px ${SECONDORY_COLOR}`,
            padding: "20px",
          }}
          data={filteredData}
          onRowClick={(evt, selectedRow) =>
            setSelectedRow(selectedRow.tableData.id)
          }
          options={{
            initialPage:state?.pageNo,
            exportCsv: (columns, data) => {
              let hArray = [];
              const headerRow = columns.map((col) => {
                if (typeof col.title === "object") {
                  return col.title.props.text;
                }
                hArray.push(col.field);
                return col.title;
              });
              const dataRows = data.map(({ tableData, ...row }) => {
                row.createdAt =
                  new Date(row.createdAt).toLocaleDateString() +
                  " " +
                  new Date(row.createdAt).toLocaleTimeString();
                row.fleetadmin = row.fleetadmin
                  ? fleetAdminsObj[row.fleetadmin]
                  : "";
                let dArr = [];
                for (let i = 0; i < hArray.length; i++) {
                  dArr.push(row[hArray[i]]);
                }
                return Object.values(dArr);
              });
              const { exportDelimiter } = ",";
              const delimiter = exportDelimiter ? exportDelimiter : ",";
              const csvContent = [headerRow, ...dataRows]
                .map((e) => e.join(delimiter))
                .join("\n");
              const csvFileName = "download.csv";
              downloadCsv(csvContent, csvFileName);
            },
            exportButton: {
              csv: settings.AllowCriticalEditsAdmin,
              pdf: false,
            },
            maxColumnSort: "all_columns",
            rowStyle: (rowData) => ({
              backgroundColor:
                selectedRow === rowData.tableData.id ? colors.ROW_SELECTED :colors.WHITE
            }),
            actionsColumnIndex: -1,
            ...TableStyle()
          }}
          localization={localization(t)}
          editable={tabValue === 2 ? undefined : {
            onRowDelete: (oldData) =>
              settings.AllowCriticalEditsAdmin
                ? new Promise((resolve) => {
                    setTimeout(() => {
                      resolve();
                      dispatch(deleteUser(oldData.id));
                      dispatch(fetchUsersOnce());
                    }, 600);
                  })
                : new Promise((resolve) => {
                    setTimeout(() => {
                      resolve();
                      alert(t("demo_mode"));
                    }, 600);
                  }),
          }}
          actions={tabValue === 2 ? [
            {
              icon: "add",
              tooltip: t("add_driver"),
              isFreeAction: true,
              onClick: (event) => navigate("/users/edituser/driver",{state:{pageNo:currentPage}}),
            }
          ] : [
            {
              icon: "add",
              tooltip: t("add_driver"),
              isFreeAction: true,
              onClick: (event) => navigate("/users/edituser/driver",{state:{pageNo:currentPage}}),
            },
            (rowData) => ({
              tooltip: t("edit"),
              icon: () => (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                  marginRight:0
                }}
              >
                <EditIcon />  
              </div>
            ),
            onClick: (event, rowData) =>{
              navigate(`/users/edituser/driver/${rowData.id}`,{state:{pageNo:currentPage}})
            }
          }),
            {
              icon: "info",
              tooltip: t("profile_page_subtitle"),
              onClick: (event, rowData) => {
                navigate(`/users/driverdetails/${rowData.id}`,{state:{pageNo:currentPage}});
              },
            },
            (rowData) => ({
              icon: () => (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    flexWrap: "wrap",
                    padding: 10,
                    backgroundColor: MAIN_COLOR,
                    borderRadius: 5,
                  }}
                >
                  <Typography style={{ color: colors.LandingPage_Background }}>
                    {t("documents")}
                  </Typography>
                </div>
              ),
              tooltip: t("documents"),
              onClick: () => navigate(`/users/userdocuments/${id}/${rowData.id}`,{state:{pageNo:currentPage}}),
            }),
          ]}
        />
        :  <BlankTable title={t('drivers_title')}  columns={baseColumns} 
      actions={[
        {
          icon: "add",
          tooltip: t("add_driver"),
          isFreeAction: true,
          onClick: (event) => navigate("/users/edituser/driver"),
        },
      ]}
      data={[]} localization={localization(t)} options={TableStyle()}/>}
        </ThemeProvider>
      <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>
        {commonAlert.msg}
      </AlertDialog>

      <Dialog 
        open={declineDialog.open} 
        onClose={() => setDeclineDialog({ open: false, rowData: null })}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>{t("decline_driver") || "Decline Driver"}</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label={t("decline_reason") || "Reason for Declining"}
            type="text"
            fullWidth
            multiline
            rows={4}
            value={declineReason}
            onChange={(e) => setDeclineReason(e.target.value)}
            placeholder={t("enter_decline_reason") || "Please provide a professional reason for declining this driver..."}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeclineDialog({ open: false, rowData: null })} style={{color: colors.BLACK}}>
            {t('cancel')}
          </Button>
          <Button onClick={handleDeclineConfirm} style={{backgroundColor: MAIN_COLOR, color: colors.WHITE}}>
            {t('confirm')}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
